import React from 'react';
import Preferences from './Preferences';
import { Helmet } from 'react-helmet';
import { PageTitles } from './pageTitle';
import { useTypedSelector } from 'src/reducers';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { useSetCandidateId } from './hooks/useSetCandidateId';
import { useSetTrackingContext } from './tracking/tealium';

export const Notifications = () => {
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);

  useSetCandidateId();

  useSetTrackingContext();

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('preferences-page-title')}`}</title>
      </Helmet>
      <Preferences />
    </>
  );
};
